import React from 'react';
import '../App.css';
import { useAppSelector } from '../app/hooks';

// icons
import { CircleAlert } from 'lucide-react';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

import { Project } from '../utils/types';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

import { fn_updateIcon } from '../utils/functions';

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function ProjectIcon(props: {
  project?: Project;
  size: number;
  colour?: string;
}) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  // global state parameters.
  const sG_darkMode: boolean = useAppSelector((state) => state.global.darkMode);

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  if (props.project === undefined) {
    return <CircleAlert width={50} height={50} strokeWidth={1.2} />;
  }

  // display the icon if one is provided.
  if ((props.project?.icon ?? undefined) !== undefined) {
    return (
      <img
        style={{
          border: 'none',
        }}
        src={
          'data:image/svg+xml;utf8,' +
          fn_updateIcon({
            original: props.project?.icon ?? '',
            colour: sG_darkMode ? '#FFFFFF' : '#000000',
            strokeWidth: 16,
            width: 50,
            height: 50,
            uriEncode: true,
          })
        }
        role="decoration"
        alt=""
        width="50"
        height="50"
      />
    );
  }

  // display a placeholder if no icon is supplied.
  return (
    <div
      className="text-colour border-colour fr"
      style={{
        flex: '0 0 ' + props.size.toString() + 'px',
        height: props.size.toString() + 'px',
        backgroundColor: 'transparent',
        fontSize: (props.size * 0.4).toString() + 'pt',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        borderRadius: (props.size / 2).toString() + 'px',
        border: '2pt solid',
      }}
    >
      {props.project?.name.toUpperCase().slice(0, 1) ?? '?'}
    </div>
  );
  //
} // ProjectIcon
